<template>
  <div
    id="app"
    class="page"
    :class="[
      this.event + ' ' + $router.currentRoute.name + '_container',
      this.isAppContainer ? 'app_container' : '',
      this.isTerminalContainer ? 'terminal_container' : '',
      contentClassData,
      layer,
      this.$route.params.pageName + '_container',
    ]"
    ref="app"
  >
    <MobileAdBannerVue
      v-if="showMobileTopBanner && showMobileBanner"
      class="top-mobile_banner"
      :carousel-props="mobileBannerTopContent"
    />
    <div
      id="page"
      class="page-content"
      :class="[
        `${
          $router.currentRoute.name !== 'PagSearchPage'
            ? $router.currentRoute.name + ' ' + mobileBannerTop
            : '' + ' ' + mobileBannerTop
        }`,
      ]"
    >
      <template v-if="init && initialized">
        <template v-if="newVMXHeader">
          <v-m-x-header-v2
            :key="componentKeyHeader"
            :hidden="preview || disableHeader"
            :class="networkingActiveClass"
            v-show="showMobileBanner"
          />
        </template>
        <template v-else>
          <v-m-x-header
            :hidden="preview || disableHeader"
            :class="networkingActiveClass"
          />
        </template>
        <ticker
          v-if="!preview"
          :hidden="preview || hideTicker || disableHeader"
          :class="networkingActiveClass"
        />
        <networking-widget
          @networkingPaddingOff="networkingWidgetPadding = false"
          @networkingActive="addNetworkingPadding"
          :hidden="preview"
          v-if="!preview && user && user.hasTicket && networkingRouteCheck"
        />
        <advertisement-popup
          v-if="!preview && event && user && !splashScreenActive"
        />
        <tv-widget />
        <freshworks v-if="!preview" />
        <data-transfer-modal
          :url="url"
          :show="dataTransferModal"
          @close="dataTransferModal = false"
        />
        <template
          v-if="
            FreshChatAllPages &&
            FreshChatAllPagesConfig &&
            FreshChatAllPagesConfig.freshChatToken &&
            currentRoute !== 'AssemblyPage'
          "
        >
          <fresh-chat
            :fresh-chat-token="FreshChatAllPagesConfig.freshChatToken"
            :enable-chat="FreshChatAllPagesConfig.enableChat"
          />
        </template>
      </template>
      <!-- <keep-alive
        :exclude="excludedPage"
      >
        <router-view
          :key="excludedPage.includes($route.name) ? componentKey : $route.fullPath"
          :class="networkingActiveClass"
          @rerender="forceRerender"
        />
      </keep-alive> -->
      <router-view
        :key="componentKey"
        :class="networkingActiveClass"
        @rerender="forceRerender"
      />
    </div>
    <div
      class="build-version"
      v-if="version && init && initialized"
    >
      <span>{{ version.Version }} | {{ version.BuildDateTimeHuman }}</span>
    </div>
    <template v-if="superUserToggle">
      <div class="vm-container content-toggle-container">
        <div class="content-toggle">
          <button
            @click.prevent="contentSwitch"
            class="content-toggle__button"
            :class="superUser ? 'active' : null"
          >
            <template v-if="superUser">
              <span>Lock content</span>
            </template>
            <template v-else>
              <span>Unlock content</span>
            </template>
          </button>
        </div>
        <div
          class="content-toggle"
          v-if="version && init && initialized && !version.Version.includes('develop')"
        >
          <button
            @click.prevent="buildSwitchDev"
            class="content-toggle__button"
          >
            <span>Development</span>
          </button>
        </div>
        <div
          class="content-toggle"
          v-if="version && init && initialized && !version.Version.includes('master')"
        >
          <button
            @click.prevent="buildSwitchProduction"
            class="content-toggle__button"
          >
            <span>Production</span>
          </button>
        </div>
      </div>
    </template>
    <div
      v-if="terminal"
      id="terminal_container-footer"
    >
      <p class="terminal_container-footer-text">
        This interactive touch screen is sponsored by
      </p>
      <img
        class="terminal_container-footer-logo"
        src="https://easddistribute.m-anage.com/from.storage?filecore=oJ9vc9NXOEKizrusP7xQGw"
      />
    </div>
    <template v-if="newVMXFooter">
      <v-m-x-footer-v2
        v-if="!preview && !disableFooter && init && initialized"
        :hidden="preview"
        class="page-footer"
        :class="mobileBannerBottom"
        id="page-footer"
      />
    </template>
    <template v-else>
      <div
        v-if="!preview && !disableFooter && init && initialized"
        class="page-footer"
        :class="mobileBannerBottom"
        id="page-footer"
        :hidden="preview"
      >
        <m-footer v-bind="footerProps" :class="networkingActiveFooterClass" />
      </div>
    </template>

    <MobileAdBannerVue
      v-if="showMobileBottomBanner && showMobileBanner"
      class="bottom-mobile_banner"
      :carousel-props="mobileBannerBottomContent"
    />
    <div>
      <cookie-notification v-if="init && initialized" :hidden="preview" />
    </div>
    <notification-toast v-if="init && initialized" :hidden="preview" />
    <a id="scrollTopButton" class="back-to-top" @click="scrollToTop()">
      <font-awesome-icon :icon="['fas', 'chevron-up']" />
    </a>

    <div
      v-if="init && initialized && boothGuruActive"
      id="bg-popup"
      style="position: fixed; z-index: 2147483647"
    />
    <!-- <booth-guru-dialog
      v-if="initialized && showBoothGuruModal && boothGuruActive"
      :hidden="preview"
      @close="showBoothGuruModal = false"
    /> -->
    <b-toast
      id="my-toast-cache-refresh"
      variant="warning"
      solid
      :no-auto-hide="true"
      :no-close-button="true"
      toaster="b-toaster-bottom-right"
      >
      <template #toast-title>
        <div>
          <strong>{{swDownload ? 'Downloading!' :'Data cached for offline use!'}}</strong>


        </div>
      </template>
      <div v-if="swDownload" class="loader-container">
        <b-spinner class="loader" />
        <span class="loader-text">{{
          $te("VMX.loading_text_pag")
            ? $t("VMX.loading_text_pag")
            : "Loading content..."
        }}</span>
        </div>
        <div v-else>
          <b-button @click="refresh()">Refresh</b-button>
          </div>
    </b-toast>
    <b-alert
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000;"
      :variant="this.condition === 'online' ? 'success' : 'danger'"
      :show="dismissCountDown"
      dismissible
      @dismissed="dismissCountDown === 0"
      @dismiss-count-down="countDownChanged"
    >
      {{ this.condition === 'online' ? 'You are online' : 'Currently on offline mode' }}
      <b-progress
        :variant="this.condition === 'online' ? 'success' : 'danger'"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      />
    </b-alert>
    <modal :show="iframeModal" @close="iframeModal = false">
      <iframe
        allowfullscreen
        :src="iframeUrl"
        style="border: 0; height: 800px; width: 100%"
        loading="lazy"
        title="#footerModalund"
      />
    </modal>
    <modal :show="iframeModal" @close="iframeModal = false">
      <iframe
        allowfullscreen
        :src="iframeUrl"
        style="border: 0; height: 800px; width: 100%"
        loading="lazy"
        title="#footerModalund"
      />
    </modal>
    <modal
      :show="exhibitorModal"
      @close="exhibitorModal = false"
      class="floorplanModal"
      id="floorplanModal"
    >
      <div class="floorplanModal-container">
        <div class="floorplanModal-container-row">
          <img
            class="floorplanModal-item image"
            :src="exhibitor ? exhibitor.LogoPath : ''"
          />
          <h1 class="floorplanModal-item headline background">
            {{ exhibitor ? exhibitor.Name : "" }}
          </h1>
          <p class="floorplanModal-item text background">
            Booth
            {{
              exhibitor && exhibitor.BoothNumbers
                ? exhibitor.BoothNumbers[0]
                : ""
            }}
          </p>
          <p class="floorplanModal-item text background">
            {{
              exhibitor && exhibitor.SponsorType ? exhibitor.SponsorType : ""
            }}
          </p>
          <button
            @click="openFloorplanCompany()"
            class="floorplanModalWrapperContent"
          >
            <span>{{ $t("VMX.show_more_button") }}</span>
          </button>
        </div>
      </div>
    </modal>
    <modal
      :show="showMobileCarousel"
      @close="closeIntroMobileCorousel()"
      :show-close-button="showMobileCarouselCloseBtn"
      :show-close-outside-button="false"
      class="intro-mobile-modal"
    >
      <Carousel
        v-bind="mobileCarouselData"
        style="border-radius: 20px"
      />
    </modal>
    <hcp-dialog
      v-if="hcpInitialized && user && hcpModalActive"
      :show="showHCPModal"
      @close="handleCloseHCPForm"
    />
    <access-denied
      v-if="onAccessDeniedDialogClose"
      @close="onAccessDeniedDialogClose = false"
    />
    <rating-reminder
      v-if="ratingReminderInitialized"
      :show="showRatingReminderModal"
      @close="handleCloseRatingReminder"
    />
    <div
      v-if="terminal"
      id="video-container"
      class="terminalvideo-container"
    >
      <img
        style="width: 100%; height: auto; display: block; position: relative"
        src="https://easddistribute.m-anage.com/from.storage?filecore=weNQ82lvP0h7DDZEHEtsJw"
      />
      <video
        width="400"
        class="terminal-video-player"
        loop
      >
        <source
          src="https://easddistribute.m-anage.com/from.storage?filecore=ZWQSZDDluee4Q68f5rE-3A"
          type="video/mp4"
        />
        Your browser does not support HTML5 video.
      </video>
      <img
        style="width: 100%; height: auto; display: block; position: relative"
        src="https://easddistribute.m-anage.com/from.storage?filecore=KEzpI-762fsPGY_eEXQeOg"
      />
    </div>
  </div>
</template>

<script>
import './assets/scss/app.scss'
import './vendor/m-footer/m-footer.css'
import EventBus from '~/states/event-bus'

import { mapActions, mapMutations, mapGetters } from 'vuex'
import NotificationToast from 'm-anage.com.vmx-components/src/NotificationToast/index.vue'
import utils from '~/utilities/utils'
import virtualMeetingAPI from '~/api/virtualMeeting'

import trackingApi from '~/api/tracking'

import instancesStateMixins from '~/mixins/instanceStateMixins'
import dialogMixins from '~/mixins/dialogMixins'
import AdvertisementPopup from '~/components/AdvertisementPopup.vue'
import tvWidget from '~/components/sidebars/tvWidget.vue'
import Freshworks from '~/components/Freshworks.vue'
import externalTrackingMixin from '~/mixins/externalTrackingMixins'
import FreshChatAllPagesMixins from '~/mixins/FreshChatAllPagesMixins'
import modal from 'm-anage.com.vmx-components/src/Modal'
import VMXHeaderV2 from '~/components/header/index.vue'
import AccessDenied from 'm-anage.com.vmx-components/src/Dialogs/AccesDeniedDialog'
import VMXFooterV2 from '~/components/footer/index.vue'
import appContainerMixins from 'm-anage.com.vmx-components/src/mixins/appContainerMixins'
import Carousel from './components/home/Carousel.vue'

import VMXHeader from './components/VMXHeader.vue'
import MFooter from './vendor/m-footer/m-footer.common'
import CookieNotification from './components/CookieNotification.vue'
import Tracking from './utilities/tracking'
import userState from './states/user'
import Ticker from './components/ticker.vue'
import config from './config'
import NetworkingWidget from './components/networkingWidget.vue'
import MobileAdBannerVue from './components/MobileAdBanner.vue'

export default {
  mixins: [
    instancesStateMixins,
    dialogMixins,
    externalTrackingMixin,
    FreshChatAllPagesMixins,
    appContainerMixins,
  ],
  data() {
    return {
      contentClassData: '',
      excludedPage: ['MyAreaPage', 'Livepage'],
      componentKey: 0,
      componentKeyHeader: 100,
      initialized: true,
      disableFooter: false,
      version: null,
      currentRoute: '',
      onAccessDeniedDialogClose: false,
      networkingActive: false,
      networkingWidgetPadding: true,
      splashScreenActive: false,
      iframeUrl: '',
      iframeModal: false,
      showMobileBanner: true,
      exhibitorModal: false,
      isAppContainer: false,
      isTerminalContainer: false,
      time: null,
      showMobileCarousel: false,
      windowWidth: window.innerWidth,
      showMobileCarouselCloseBtn: false,
      exhibitor: null,
      gTagScript: null,
      condition: 'online',
      dismissSecs: 10,
      dismissCountDown: 0,
      // showBoothGuruModal: false,
    }
  },
  components: {
    VMXHeader,
    Ticker,
    MFooter,
    CookieNotification,
    NotificationToast,
    NetworkingWidget,
    AdvertisementPopup,
    tvWidget,
    Freshworks,
    modal,
    MobileAdBannerVue,
    Carousel,
    VMXHeaderV2,
    VMXFooterV2,
    AccessDenied,
  },
  provide: {
    TrackingUtil: Tracking,
  },
  computed: {
    ...mapGetters({
      init: "instancesState/getInitializedHead",
      swDownload: "instancesState/getSWDownload",
    }),
    layer() {
      if (localStorage.getItem('isVMX') === 'true') return 'vmx-context'
      if (localStorage.getItem('isApp') === 'true') return 'app-context'
      if (localStorage.getItem('isTerminal') === 'true') { return 'terminal-context' }
      return ''
    },
    footerProps() {
      return {
        apiBaseUrl: `${this.$store.getters['instancesState/getApiBaseUrl']}/`,
        language: this.language,
        shortname: this.event,
        context: 'Event',
      }
    },
    hideTicker() {
      return (
        this.backendConfig.defaults?.hideTicker
        && this.currentRoute === 'HomePage'
      )
    },
    mobileBannerTop() {
      const mobileBannerTop = this.backendConfig?.defaults?.mobileBannerTop
      if (this.isAppContainer && mobileBannerTop) {
        return 'mobile_banners_top'
      }

      return ''
    },
    mobileBannerBottom() {
      const mobileBannerBottom = this.backendConfig?.defaults?.mobileBannerBottom
      if (this.isAppContainer && mobileBannerBottom) {
        return 'mobile_banners_bottom'
      }

      return ''
    },
    showMobileTopBanner() {
      const mobileBannerTop = this.backendConfig?.defaults?.mobileBannerTop
      if (this.isAppContainer && mobileBannerTop) {
        return true
      }
      return false
    },
    showMobileBottomBanner() {
      const mobileBannerBottom = this.backendConfig?.defaults?.mobileBannerBottom
      if (this.isAppContainer && mobileBannerBottom) {
        return true
      }
      return false
    },
    terminal() {
      return localStorage.getItem('isTerminal')
    },
    mobileCarouselData() {
      return this.backendConfig?.defaults?.mobileCarousel?.Carousel
    },

    mobileBannerBottomContent() {
      return this.backendConfig?.defaults?.mobileBannerBottom
    },
    mobileBannerTopContent() {
      return this.backendConfig?.defaults?.mobileBannerTop
    },
    moreSpaceConfig() {
      return this.backendConfig.defaults?.disableVMXFooter
    },
    user() {
      return userState.getUser(this.instance)
    },
    hcpModalActive() {
      return this.configForKey('app_config').config[0].defaults.showHCPModal
    },
    gTagConfig() {
      return this.configForKey('app_config')?.config[0]?.defaults.gtagConfig
    },
    networkingActiveClass() {
      if (this.networkingWidgetPadding) {
        return this.networkingActive
          && document.getElementById(
            'networking-widget__sidebar',
            // eslint-disable-next-line max-len
          )?.childNodes.length > 0
          && !this.preview
          && this.currentRoute !== 'UserFormPage'
          && this.currentRoute !== 'NoaccessPage'
          ? 'networking-padding-right'
          : null
      }
      return null
    },
    networkingActiveFooterClass() {
      if (this.networkingWidgetPadding) {
        return this.networkingActive
          && document.getElementById(
            'networking-widget__sidebar',
            // eslint-disable-next-line max-len
          )?.childNodes.length > 0
          && !this.preview
          && this.currentRoute !== 'UserFormPage'
          && this.currentRoute !== 'NoaccessPage'
          ? 'networking-padding-right networking-padding-bottom'
          : null
      }
      return null
    },
    showNetworkingOnHomepage() {
      return (
        this.backendConfig.defaults?.NetworkingWidget
          ?.showNetworkingOnHomepage || false
      )
    },
    NetworkingOnPages() {
      return (
        this.backendConfig.defaults?.NetworkingWidget?.NetworkingOnPages || []
      )
    },
    FreshChatAllPages() {
      return (
        this.$route.name !== 'IndustryLandingPageProfile'
        && this.$route.name !== 'ProfilePage'
      )
    },
    networkingRouteCheck() {
      return (
        this.currentRoute !== 'UserFormPage'
        && this.currentRoute !== 'NoaccessPage'
        && this.currentRoute !== 'AssemblyPage'
        && this.currentRoute !== 'SurveyPage'
      )
    },
    newVMXHeader() {
      return !!this.backendConfig.defaults?.newVMXHeader
    },
    newVMXFooter() {
      return !!this.backendConfig?.defaults?.newVMXFooter
    },
  },
  created() {
    window.addEventListener('isAppContainer', this.setAppContainer)
    window.addEventListener('isTerminalContainer', this.setTerminalContainer)
    window.addEventListener('resize', this.onResize)

    if (localStorage.getItem('isTerminal') === 'true') { this.setTerminalContainer() }

    if (localStorage.getItem('isApp') === 'true') this.setAppContainer()
  },
  async mounted() {

    if(this.event === "ean2023") {
      this.$loadScript('https://d2t0unnjxes6lt.cloudfront.net/data/ean/data/assets/js/sw.js')
      this.$loadScript('https://d2t0unnjxes6lt.cloudfront.net/data/ean/data/assets/js/e.js',{
        'id':'_etLoader',
        'data-block-cookies':'true',
        'data-respect-dnt':'true',
        'data-product-identifier':'signalize',
        'charset':'UTF-8',
        'data-secure-code':'OXExjV'
      })
    }
    window.addEventListener('scroll', this.handleScroll)
    this.contentClass()
    this.version = await virtualMeetingAPI.getBuildVersion()
    EventBus.$on('rerender', () => {
      this.forceRerender()
    })
    this.$root.$on('rerender', () => {
      this.forceRerender()
    })
    EventBus.$on('noaccess', (params) => {
      this.onAccessDeniedDialogClose = params
    })
    this.$root.$on('externalTrackingDataTransfer', (url) => {
      this.url = url
      this.dataTransferModal = true
    })
    // if (instancesStateMixins.computed.boothGuruActive) {
    //   dialogMixins.methods.callBoothGuruDialog()
    //   window.addEventListener('boothGuru', this.receiveMessage)
    // }
    window.openFooterModal = (url) => {
      this.iframeUrl = url
      this.iframeModal = true
    }

    // hide top and bottom banners when image map on full screen
    if (this.event === 'ewma2023') {
      window.onpopstate = () => {
        if (this.showMobileBanner === false) {
          this.showMobileBanner = true
        }
      }
      window.hideMobileBanner = () => {
        this.showMobileBanner = false
      }
      window.showMobileBanner = () => {
        this.showMobileBanner = true
      }
    }
    this.removeMobileCarouselShown()
    dialogMixins.methods.callHCPDialog()
    window.addEventListener('hcpDialog', this.receiveMessage)
    dialogMixins.methods.callRatingReminder()
    window.addEventListener('ratingReminder', this.receiveMessage)
    window.addEventListener('routerEvent', this.receiveMessage)
    window.addEventListener('scrollToTop', this.receiveMessage)

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    window.tracking = async (
      sourceContentAction,
      entityId,
      sourceContext,
      target,
      link,
      openModal = true,
    ) => {
      localStorage.removeItem('wentBack')
      const fullscreen = document.getElementsByClassName('fullscreen')
      if (this.isAppContainer && !fullscreen.length) return
      await this.windowActionTracking(
        sourceContentAction,
        entityId,
        sourceContext,
      )
      if (utils.isUrl(link)) {
        if (sourceContentAction === 'vmx-imageMap-link' && openModal) {
          this.exhibitor = await this.getExhibitorProfileById(
            link.substring(link.lastIndexOf('/') + 1),
          )

          this.exhibitorModal = true
        } else {
          window.open(link, target)
        }
      } else if (utils.isObject(link)) {
        if (sourceContentAction === 'vmx-imageMap-link' && openModal) {
          this.exhibitor = await this.getExhibitorProfileById(
            link.substring(link.lastIndexOf('/') + 1),
          )
          this.exhibitorModal = true
        } else {
          this.$router.push(
            utils.getRouteWithDefaultParams(link.name, link.params),
          )
        }
      } else if (
        sourceContentAction === 'vmx-imageMap-link'
        && openModal
        && link
      ) {
        this.exhibitor = await this.getExhibitorProfileById(
          link.substring(link.lastIndexOf('/') + 1),
        )
        this.exhibitorModal = true

        if (localStorage.getItem('isTerminal') === 'true') {
          setTimeout(() => {
            const parentEl = document.querySelector('#imagemap1-container')
            const childEl = document.querySelector('#floorplanModal')
            if (!parentEl?.contains(childEl) && childEl != null) {
              const source = document.getElementById('imagemap1-container')
              const child = document.getElementById('floorplanModal')
              if (source) source.appendChild(child)
            }
          }, 500)
        }
      } else {
        window.open(link, target)
      }
    };

    window.clearcache = () => {
      localStorage.removeItem('cachedDate')

      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      });

      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
      });

      if (window.navigator && navigator.serviceWorker) {
        navigator.serviceWorker
          .getRegistrations()
          .then(function (registrations) {
            for (let registration of registrations) {
              registration.unregister();
            }
          });
      }

      if ("caches" in window) {
        caches.keys().then(function (keyList) {
          return Promise.all(
            keyList.map(function (key) {
              return caches.delete(key);
            })
          );
        });
      }

      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .getRegistrations()
          .then(function (registrations) {
            for (const registration of registrations) {
              // unregister service worker
              console.log("serviceWorker unregistered");
              registration.unregister();

              setTimeout(function () {
                console.log("trying redirect do");
                window.location.replace(window.location.href); // because without redirecting, first time on page load: still service worker will be available
              }, 3000);
            }
          });
      }
    }


    this.setUrConfig({
      oauthUrl: config.getInstanceConfig(this.instance)?.oauthUrl,
      identityUrl: this.identityUrl,
      apiUrl: this.apiUrl,
      clientId: config.getInstanceConfig(this.instance)?.oauth2.clientId,
      instance: this.instance,
      language: this.language,
      eventShort: this.event,
      context: 'Event',
      returnUrl: this.returnUrl,
    })
    this.observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName)
        this.$nextTick(() => {
          this.onClassChange(newValue, m.oldValue)
        })
      }
    })
    this.observer.observe(this.$refs.app, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    })
    window.openLink = (url) => {
      this.openLink(url)
    }
  },
  watch: {
    gTagConfig() {
      if (this.gTagConfig?.isActive) {
        this.appendGtag()
      }
    },
    swDownload(val) {
      if(val) this.showToast()
    },
    init() {
      const appContainer = document.getElementById('app')
      appContainer.classList.remove(...appContainer.classList)
      appContainer.classList.add(
        this.$store.getters['instancesState/getEvent'],
      )
      appContainer.classList.add(this.$route.name)
    },
    firstError() {
      if (
        this.firstError?.response
        && this.firstError.response.status === 401
      ) {
        let tries = localStorage.getItem('VMXreload')
          ? parseInt(localStorage.getItem('VMXreload'), 10)
          : 0
        tries += 1
        localStorage.setItem('VMXreload', tries)
        userState.unsetUser(this.instance)
        this.$store.commit('instancesState/setToken', null)

        const reloadRoute = {
          name: this.$router.history.pending.name,
          query: this.$router.history.pending.query,
          params: this.$router.history.pending.params,
        }
        if (
          Object.prototype.hasOwnProperty.call(
            reloadRoute.query,
            'access_token',
          )
        ) {
          delete reloadRoute.query.access_token
        }
        this.clearErrors()
        if (tries <= 3) {
          this.$router.replace(reloadRoute)
        } else {
          localStorage.removeItem('VMXreload')
        }
      }
    },
    networkingActive(val) {
      this.showNetworkingWidgetForPages(val)
    },
    $route() {
      if (this.backendConfig?.defaults?.favicon) {
        utils.changeFavicon(this.backendConfig.defaults.favicon)
      }
      this.scrollToTop()
      if (
        this.$router.currentRoute.name === 'HoldingPage'
        || (!this.backendConfig.OnboardingV2
          && this.$router.currentRoute.name === 'AuthPage')
      ) {
        this.initialized = false
      } else if (this.$router.currentRoute.name !== '') {
        this.initialized = true
      }

      // Todo remove after a year

      if (
        this.$router.currentRoute.name === 'IndustryLandingPage'
        && !!this.$router.currentRoute.query.id
      ) {
        this.forceRerender()
      }

      if (
        this.$router.currentRoute.name === 'ProfilePage'
        && !!this.$router.currentRoute.params.companyAccountId
      ) {
        this.forceRerender()
      }

      this.currentRoute = this.$router.currentRoute.name
      this.showNetworkingWidgetForPages(this.networkingActive)
      // eslint-disable-next-line max-len
      this.disableFooter = config.getMoreSpaceConfig(
        this.$router.currentRoute.name,
        this.moreSpaceConfig,
      )
      this.setMobileCarousel()
    },
  },
  beforeDestroy() {
    window.removeEventListener('ratingReminder', this.receiveMessage)
    window.removeEventListener('routerEvent', this.receiveMessage)
    // if (instancesStateMixins.computed.boothGuruActive) {
    //   window.removeEventListener('boothGuru', this.receiveMessage)
    // }
    this.observer.disconnect()
    localStorage.removeItem('nextPage')
  },
  methods: {
    ...mapMutations({
      setUrConfig: 'ModuleConfig/setUrlConfigs',
      setIsAppContainer: 'instancesState/setIsAppContainer',
      setIsTerminalContainer: 'instancesState/setIsTerminalContainer',
    }),
    showToast() {
        this.$bvToast.show("my-toast-cache-refresh")
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    refresh() {
      window.location.reload()
    },
    onResize(e) {
      this.windowWidth = window.innerWidth
    },
     swattack() {
      navigator.serviceWorker?.ready
                ?.then((registration) => {
                    console.log('[APP SW] is readybooo');
                    // 2. Zugriff auf aktiven SW erhalten
                    if (registration.active) {

                        // 3. Nachricht senden
                        registration.active.postMessage({
                            msg: 'skipWaiting'

                        });
                    } else {
                        // console.log("[APP SW] not active", registration)
                    }
                })
                .catch((err) => {
                    console.log('[APP SW] is not ready', err);
                });
    },
    updateOnlineStatus(event) {
       this.condition = navigator.onLine ? "online" : "offline";
       this.dismissCountDown = this.dismissSecs
    },
    contentClass() {
      if (localStorage.getItem('content')) {
        this.contentClassData = `is-${localStorage.getItem('content')}-content`
        return
      }
      this.contentClassData = ''
    },
    closeIntroMobileCorousel() {
      const mobileCarousel = this.backendConfig?.defaults?.mobileCarousel
      this.showMobileCarousel = false
      localStorage.setItem(
        'mobileCarouselShown',
        JSON.stringify({
          shown: true,
          showOnReload: mobileCarousel.showOnReload,
        }),
      )
    },
    async receiveMessage(event) {
      if (event?.detail?.message === 'hcpDialog') {
        this.hcpInitialized = true
        this.showHCPModal = true
      }

      if (event?.detail?.message === 'ratingReminder') {
        this.showRatingReminderModal = true
        this.ratingReminderInitialized = true
      }

      if (event?.detail?.message === 'rerouteParent') {
        this.$router.push(event.detail.destination)
      }
      if (event?.detail?.message === 'scrollToTop') {
        this.scrollToTop()
      }
    },
    checkifcontains(parent, child) {
      return parent !== child && parent.contains(child)
    },
    openFloorplanCompany() {
      const link = this.exhibitor ? this.exhibitor.DeepLink : ''
      const url = new URL(link)
      window.open(window.location.origin + url.pathname, '_self')
    },
    setMobileCarousel() {
      const mobileCarousel = this.backendConfig?.defaults?.mobileCarousel
      const mobileCarouselShown = JSON.parse(
        localStorage.getItem('mobileCarouselShown'),
      )
      if (
        mobileCarousel
        && this.$route.name === 'HomePage'
        && mobileCarouselShown?.shown !== true
        && this.isAppContainer
      ) {
        this.showMobileCarousel = true
        this.setMobileCarouselCloseBtn()
      } else {
        this.showMobileCarousel = false
      }
    },
    removeMobileCarouselShown() {
      const mobileCarouselShown = JSON.parse(
        localStorage.getItem('mobileCarouselShown'),
      )
      if (mobileCarouselShown?.showOnReload === true) {
        localStorage.removeItem('mobileCarouselShown')
      }
    },
    waitForCloseBtn(seconds) {
      const ms = seconds * 1000
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async setMobileCarouselCloseBtn() {
      const { minDuration } = this.backendConfig?.defaults.mobileCarousel
      if (minDuration) {
        await this.waitForCloseBtn(minDuration)
        this.showMobileCarouselCloseBtn = true
      }
      this.showMobileCarouselCloseBtn = true
    },
    setAppContainer() {
      this.setIsAppContainer(true)
      this.isAppContainer = true
      localStorage.setItem('isApp', true)

      if (
        this.event === 'dkk2022'
        && JSON.parse(localStorage.getItem('vmx-loaded')) === null
      ) { localStorage.setItem('vmx-loaded', false) }
    },
    setTerminalContainer() {
      this.setIsTerminalContainer(true)
      this.isTerminalContainer = true
      localStorage.setItem('isTerminal', true)
    },
    appendGtag() {
      if (this.gTagScript === null) {
        this.gTagScript = document.createElement('script')
        this.gTagScript.innerHTML = this.backendConfig.defaults.gtagConfig.gtagScript
        document.head.appendChild(this.gTagScript)
      }
    },
    showNetworkingWidgetForPages(networkingActive) {
      let showNetworkingForPages = false
      if (this.NetworkingOnPages.includes(this.$router.currentRoute.name)) {
        showNetworkingForPages = true
      }
      if (
        this.showNetworkingOnHomepage
        && !JSON.parse(localStorage.getItem('networking-popup-loaded'))
        && showNetworkingForPages
      ) {
        if (networkingActive) {
          window.jmeNetworking.openAreaOfInterest({}, document.body)
          localStorage.setItem('networking-popup-loaded', true)
        }
      }
    },
    scrollToTop() {
      window.scrollToTopNew()
    },
    ...mapActions({
      clearErrors: 'Error/clearErrors',
      getExhibitorProfileById: 'ILPExhibitorProfile/getProfileById',
    }),
    contentSwitch() {
      if (this.superUser) {
        this.$store.commit('instancesState/setSuperUser', false)
        localStorage.removeItem('sUser')
      } else {
        this.$store.commit('instancesState/setSuperUser', true)
        localStorage.setItem('sUser', 'true')
      }
    },
    buildSwitchDev() {
      window.open(`https://vmx-dev.m-anage.com${this.$route.fullPath}`, '_self')
    },
    buildSwitchProduction() {
      if (config.getDomainConfigWithEvent(this.$route.params.event)) {
        window.open(`https://${config.getDomainConfigWithEvent(this.$route.params.event)}${this.$route.fullPath}`, '_self')
      } else {
        window.open(`https://vmx.m-anage.com${this.$route.fullPath}`, '_self')
      }
    },
    forceRerender() {
      this.contentClass();
      this.componentKey += 1;
      this.componentKeyHeader += 1;
    },
    addNetworkingPadding() {
      this.networkingActive = true
    },
    async windowActionTracking(sourceContentAction, entityId, sourceContext) {
      if (sourceContentAction && sourceContext) {
        trackingApi.trackCustomAction(
          sourceContentAction,
          entityId,
          sourceContext,
        )
      }
    },
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(' ')
      this.splashScreenActive = !!classList.includes('hasSplashscreen')
    },
  },
}
</script>
<style lang="scss">

#my-toast-cache-refresh {
 .toast-header {
  padding: 0 !important;
 }

 .loader-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
 }

 .loader {
  height: 1rem !important;
  width: 1rem !important;
 }
}
.pag-result-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-top: 3rem;
}
.terminalvideo-container {
  display: none;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
}
.terminalvideo-container.fullscreen {
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0px;
  left: 0px;
}
.terminalvideo-container.fullscreenvid {
  display: block;
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 135px;
  left: 0px;
  z-index: 2;
  buttons {
    display: none;
  }
}
.terminalvideo-container video {
  width: 100vw !important;
  height: auto;
}
body {
  #app {
    overflow-y: scroll;
    height: 100vh;
  }
  .mobile_banners_top {
    margin-top: 75px;
    margin-bottom: 75px;
  }
  .mobile_banners_bottom {
    margin-bottom: 75px;
  }
  .bottom-mobile_banner {
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 75px;
    z-index: 4;
  }
  .top-mobile_banner {
    position: fixed;
    top: 0;
    left: 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 75px;
    z-index: 1;
    margin-bottom: 50px;
  }
  .intro-mobile-modal {
    .ipl-modal__content {
      padding: 0;
      height: 95%;
      width: 95%;
      max-width: 95%;
      margin: 0;
    }
  }
  .floorplanModal-container {
    height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }
  .floorplanModal-container-row {
    width: 90%;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    button {
      outline: none;
      border: none;
      margin-top: 10px;
      background-color: #4a5b7c;
      color: white;
      width: 100%;
      padding: 5px;
      font-weight: bold;
    }
  }
  .floorplanModal-item {
    padding: 5px;
    width: 100%;
    height: auto;
    align-self: left;
    margin: 0;
    font-size: 2em;
    text-align: center;
    flex-direction: column;
    &.background {
      background-color: #f8f9fa;
    }
    &.headline {
      font-weight: bold;
      font-size: 25px;
    }
    &.image {
      margin-bottom: 15px;
    }
    &.text {
      font-weight: normal;
      font-size: 16px;
    }
  }
  .floorplanModal {
    .ipl-modal__content {
      max-width: 450px;
      width: auto;
    }
  }
}
</style>
